import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { ConfigType } from 'src/domains/layouts/config/features/types';
import { AmountPrecision } from 'src_common/common/amount/AmountPrecision';
import { Common } from 'src/domains/common/Common';

export class ConfigState {
    public constructor(private readonly common: Common) {}

    public get commonConfig(): ConfigType {
        const features = ConfigComponents.get(this.common);
        return features.config;
    }

    public get precision(): AmountPrecision {
        return new AmountPrecision(this.commonConfig.decimalLength);
    }
}
